import { createContext } from 'react';

export const ButtonGroupContext = createContext({
    isInGroup: false,
    isMobile: false
});
